export function Comments({ commentText }: { commentText?: string }) {
  const lines = commentText?.split(/\r?\n/) ?? [];

  return (
    <>
      <h2 className="p-2">Comments/Notes:</h2>
      <ul>
        {lines.map((line, index) => {
          return <li key={`line-${index}-${line}`}>{line}</li>;
        })}
      </ul>
    </>
  );
}
